import { Head, Link } from "@inertiajs/react"
import { FiArrowLeft, FiGrid } from "react-icons/fi"

type Category = { slug: string; label: string; count: number }

type Props = {
  categories: Category[]
  canonical_url: string
}

export default function Explore({ categories, canonical_url }: Props) {
  const title = "מציאת עסקים ובעלי מקצוע | Cardly"
  const description = "מצאו עסקים ובעלי מקצוע עם כרטיס ביקור דיגיטלי, פרטי קשר, וואטסאפ, גלריה ועוד."
  const structuredData = JSON.stringify({
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name: title,
    description,
    url: canonical_url,
    mainEntity: { "@type": "ItemList", itemListElement: categories.map((category, index) => ({ "@type": "ListItem", position: index + 1, name: category.label, url: `/explore/${category.slug}` })) },
  }).replace(/</g, "\\u003c")

  return (
    <>
      <Head title={title}>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <link rel="canonical" href={canonical_url} />
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: structuredData }} />
      </Head>
      <main className="min-h-screen bg-slate-50 px-4 py-8 text-slate-900 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-5xl">
          <Link href="/" className="inline-flex items-center gap-2 text-sm font-medium text-brand-700 hover:text-brand-800"><FiArrowLeft aria-hidden="true" />Cardly</Link>
          <div className="mt-10 max-w-2xl">
            <p className="text-sm font-semibold text-brand-700">Cardly</p>
            <h1 className="mt-2 text-3xl font-bold sm:text-4xl">מצאו את העסק הבא שלכם</h1>
            <p className="mt-3 text-lg leading-8 text-slate-600">כרטיסי ביקור דיגיטליים של עסקים ובעלי מקצוע בישראל.</p>
          </div>
          {categories.length === 0 ? <div className="glass-card mt-8 p-8 text-center text-slate-600">קטגוריות יופיעו כאן כשיתווספו כרטיסים.</div> : (
            <div className="mt-8 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
              {categories.map((category) => <Link key={category.slug} href={`/explore/${category.slug}`} className="glass-card group flex items-center gap-4 p-5 transition hover:-translate-y-0.5 hover:shadow-xl"><span className="grid h-12 w-12 place-items-center rounded-2xl bg-brand-50 text-brand-700"><FiGrid aria-hidden="true" /></span><span className="flex-1"><span className="block font-semibold group-hover:text-brand-700">{category.label}</span><span className="mt-1 block text-sm text-slate-500">{category.count} כרטיסים</span></span><FiArrowLeft className="text-slate-400" aria-hidden="true" /></Link>)}
            </div>
          )}
        </div>
      </main>
    </>
  )
}
